import { ApolloCache } from "@apollo/client"

import { filterTree } from "shared/lib/treeUtils"
import { ProjectTypename } from "shared/types/Project"

import { getProjectChildren } from "./getProjectChildren"
import { updateProjectChildren } from "./updateProjectChildren"

export function removeProjectChildFromProject(
  cache: ApolloCache<object>,
  projectID: string,
  childID: string
) {
  const children = getProjectChildren(projectID, ProjectTypename, cache)
  if (children) {
    updateProjectChildren({
      parentID: projectID,
      parentType: ProjectTypename,
      children: filterTree(children, child => child.id !== childID),
      cache
    })
  }
}
